var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyDevBoxEnvironment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1928_275599",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1928_275599)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_1928_275599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.248 33.2467C21.2277 21.1935 31.679 12 44.2765 12C56.874 12 67.3252 21.1935 69.305 33.2467C78.9791 34.1437 86.5529 42.2927 86.5529 52.2131C86.5529 62.7333 78.0355 71.2614 67.5285 71.2614H21.0244C10.5175 71.2614 2 62.7333 2 52.2131C2 42.2927 9.57404 34.1437 19.248 33.2467Z",
    fill: "#8DC8E8",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_1928_275599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2713 30.7692C43.3596 29.5125 45.3064 29.5125 46.3946 30.7692L59.2548 45.6201C60.7879 47.3905 59.5327 50.1467 57.193 50.1467H50.2028V71.2642C50.2028 71.2642 48.9808 71.2642 47.4734 71.2642H41.1945C39.6871 71.2642 38.4651 71.2642 38.4651 71.2642V50.1467H31.473C29.1334 50.1467 27.8782 47.3905 29.4113 45.6201L42.2713 30.7692Z",
    fill: "url(#paint0_linear_1928_275599)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1928_275599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.68457 84.9766H85.0406V91.3436C85.0406 92.6257 84.0012 93.6651 82.7191 93.6651H6.00604C4.72393 93.6651 3.68457 92.6257 3.68457 91.3436V84.9766Z",
    fill: "url(#paint1_linear_1928_275599)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.086 76.8818C74.6179 76.4966 74.0421 76.2881 73.4529 76.2881H15.1673C14.5781 76.2881 14.0024 76.4966 13.5343 76.8818L3.68457 84.9766H84.9357L75.086 76.8818Z",
    fill: "url(#paint2_linear_1928_275599)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_1928_275599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.937 132.53C112.196 130.999 111.852 123.997 111.899 112.676H94.511C94.511 123.997 94.2174 130.999 85.4725 132.53C84.2855 132.733 83.2005 133.391 82.4029 134.389C81.6054 135.387 81.1448 136.664 81.1016 138H125.305C125.262 136.664 124.801 135.387 124.004 134.389C123.206 133.391 122.121 132.733 120.934 132.53H120.937Z",
    fill: "url(#paint3_linear_1928_275599)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_1928_275599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.664 55H68.3357C63.1797 55 59 59.2217 59 64.4293V105.5C59 110.708 63.1797 114.93 68.3357 114.93H138.664C143.82 114.93 148 110.708 148 105.5V64.4293C148 59.2217 143.82 55 138.664 55Z",
    fill: "url(#paint4_linear_1928_275599)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_diiii_1928_275599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0245 102.714L109.072 65.101C109.653 63.7374 111.226 63.1053 112.585 63.6891C113.847 64.2313 114.48 65.6312 114.098 66.9202L113.992 67.2153L97.9449 104.829C97.3632 106.192 95.7901 106.824 94.4314 106.241C93.1697 105.698 92.5365 104.298 92.9182 103.009L93.0245 102.714ZM77.5221 83.0595L88.227 72.3164C89.2722 71.2676 90.9666 71.2676 92.0118 72.3164C92.9765 73.2846 93.0507 74.8081 92.2344 75.8617L92.0118 76.1147L83.1992 84.9589L92.0118 93.8026C93.0569 94.8517 93.0569 96.5521 92.0118 97.6012C91.047 98.5691 89.529 98.6438 88.4791 97.8246L88.227 97.6012L77.5221 86.858C76.5574 85.8898 76.4832 84.3661 77.2995 83.3127L77.5221 83.0595ZM114.987 72.3131C115.952 71.3449 117.47 71.2705 118.52 72.0898L118.772 72.3133L129.479 83.0597C130.444 84.0282 130.518 85.5527 129.7 86.6061L129.478 86.8591L118.771 97.5904C117.725 98.6384 116.03 98.6374 114.986 97.5877C114.022 96.619 113.948 95.0953 114.766 94.0425L114.988 93.7895L123.801 84.9575L114.987 76.1114C113.942 75.0625 113.942 73.3619 114.987 72.3131Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_1928_275599",
    x: 0.422771,
    y: 10.4228,
    width: 86.13,
    height: 61.8427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.004
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.00801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-dodge",
    in2: "shape",
    result: "effect1_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.56075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "effect1_innerShadow_1928_275599",
    result: "effect2_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.57723,
    dy: -1.57723
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.29555 0 0 0 0 0.575 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_innerShadow_1928_275599",
    result: "effect3_innerShadow_1928_275599"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_1928_275599",
    x: 28.7383,
    y: 28.3211,
    width: 31.5658,
    height: 43.6959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376393,
    dy: 0.752787
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275599",
    result: "effect2_innerShadow_1928_275599"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1928_275599",
    x: 3.68457,
    y: 84.0854,
    width: 81.5792,
    height: 10.0252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.891129
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11391
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.222782,
    dy: 0.445565
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11391
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275599",
    result: "effect2_innerShadow_1928_275599"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_1928_275599",
    x: 81.1016,
    y: 111.17,
    width: 44.5805,
    height: 27.5823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376393,
    dy: 0.752787
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275599",
    result: "effect2_innerShadow_1928_275599"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_1928_275599",
    x: 59,
    y: 53.4944,
    width: 89.3764,
    height: 62.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376393,
    dy: 0.752787
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275599",
    result: "effect2_innerShadow_1928_275599"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_diiii_1928_275599",
    x: 72.9761,
    y: 61.9668,
    width: 61.0487,
    height: 52.0155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.76214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1928_275599",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.376214,
    dy: -0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752427
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376214,
    dy: 0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752427
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1928_275599",
    result: "effect3_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376214,
    dy: 0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1928_275599",
    result: "effect4_innerShadow_1928_275599"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50485
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_1928_275599",
    result: "effect5_innerShadow_1928_275599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1928_275599",
    x1: 37.5418,
    y1: 24.5947,
    x2: 76.0114,
    y2: 50.6428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445972,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895626,
    stopColor: "#2A446F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1928_275599",
    x1: 85.0406,
    y1: 62.6983,
    x2: 85.0406,
    y2: 89.4322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#51E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1928_275599",
    x1: 19.2793,
    y1: 74.0603,
    x2: 29.0818,
    y2: 101.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#51E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1928_275599",
    x1: 103.206,
    y1: 112.793,
    x2: 103.206,
    y2: 135.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18878,
    stopColor: "#75757A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1928_275599",
    x1: 84.121,
    y1: 47.4331,
    x2: 141.613,
    y2: 124.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445972,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895626,
    stopColor: "#2A446F"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyDevBoxEnvironment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Empty_DevBoxEnvironment.cd3dddc726cb027078f00fda57c697b9.svg";